import { QueryAreasArgs } from 'graphqlAPI'
import api from '..'

const download = (variables?: QueryAreasArgs) => {
  return api.post<string>(`areas/download`, variables)
}

export default download
